import Block from '@/components/Block'
import Button from '@/components/Button'
import Checkbox from '@/components/Checkbox'
import DateDisplay from '@/components/DateDisplay'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { bulkBookings } from '@/lib/bulkBookings'
import { BookMultipleSessionsSection } from '@/shared/api-generated-types'
import React, { useState } from 'react'
import * as styles from './style'

export interface Props extends BookMultipleSessionsSection {
  setIsSuccess: React.Dispatch<React.SetStateAction<boolean>>
}

const MultiSessionsBooking = ({ title, subtitle, items, setIsSuccess }: Props): JSX.Element => {
  const unbookedSessions = items.filter((item) => item.booked === false)
  const availableSessions = unbookedSessions.map((item) => item.sessionId)

  const [selected, setSelected] = useState<string[]>(availableSessions.map((item) => item))
  const [isLoading, setIsLoading] = useState<boolean>(false)

  function handleOnChange(event: React.ChangeEvent<HTMLInputElement>): void {
    const { checked: isChecked, value: sessionId } = event.target
    const index = selected.indexOf(sessionId)
    if (isChecked) {
      if (index === -1) setSelected([...selected, sessionId])
    } else {
      if (index !== -1) {
        selected.splice(index, 1)
        setSelected(selected)
      }
    }
  }

  function handleOnSubmit(): void {
    setIsLoading(true)
    bulkBookings({ sessionIds: selected })
      .then((response) => {
        if (response) {
          setIsSuccess(true)
        } else {
          setIsLoading(false)
        }
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  return (
    <>
      <Text tag="div" size="sm" weight="lg" responsiveSize={{ md: 'md', lg: 'lg' }}>
        {title}
      </Text>
      <Text tag="div" size="xxs" weight="sm" className="pb-sm ta-c" responsiveSize={{ xs: 'xs' }}>
        {subtitle}
      </Text>
      <Block theme="white" className={styles.sessionsContainer}>
        {items &&
          items.map(({ title, start, sessionId }, index) => (
            <label htmlFor={`sessionId-${index}`} key={index}>
              <Stack x className={`${styles.session} pt-sm pb-sm`}>
                <Checkbox
                  label
                  defaultChecked={true}
                  name={`sessionId-${index}`}
                  value={sessionId}
                  onChange={handleOnChange}
                  disabled={selected.indexOf(sessionId) !== -1 ? false : true}
                  className="pr-sm"
                />
                <Stack y>
                  <Text tag="div" size="xxs" weight="lg" responsiveSize={{ lg: 'xs' }}>
                    {title}
                  </Text>
                  <Text tag="div" size="xxs" weight="sm">
                    <Stack x>
                      <DateDisplay abbreviated value={start} />
                      {selected.indexOf(sessionId) !== -1 ? null : (
                        <Text tag="div" size="xxs" weight="sm">
                          (Already Booked)
                        </Text>
                      )}
                    </Stack>
                  </Text>
                </Stack>
              </Stack>
            </label>
          ))}
      </Block>
      <Button loading={isLoading} label={title} size="md" onClick={handleOnSubmit} iconLeft="checkbox" />
    </>
  )
}
export default MultiSessionsBooking
